import { apiFetch } from "./client";

export type Provider = "dlocal" | "bancard" | "pagopar" | "dinelco" | "dpago";
export type ProviderMode = "sandbox" | "live";
export type FxStrategy = "reject_others" | "delegate_provider" | "freeze_own";

export interface ProviderConfig {
  id: string;
  merchantId: string;
  provider: Provider;
  mode: ProviderMode;
  country: string;
  fxStrategy: FxStrategy;
  priority: number;
  active: boolean;
  hasCredentials: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface ProviderConfigList {
  data: ProviderConfig[];
  nextCursor: string | null;
}

export interface CreateProviderConfigInput {
  provider: Provider;
  mode: ProviderMode;
  country: string;
  credentials: Record<string, unknown>;
  fxStrategy?: FxStrategy;
  priority?: number;
  active?: boolean;
}

export interface UpdateProviderConfigInput {
  credentials?: Record<string, unknown>;
  fxStrategy?: FxStrategy;
  priority?: number;
  active?: boolean;
}

export const listProviderConfigs = (merchantId: string) =>
  apiFetch<ProviderConfigList>(
    `/admin/merchants/${merchantId}/provider-configs`,
  );

export const createProviderConfig = (
  merchantId: string,
  body: CreateProviderConfigInput,
) =>
  apiFetch<ProviderConfig>(`/admin/merchants/${merchantId}/provider-configs`, {
    method: "POST",
    body,
  });

export const updateProviderConfig = (
  merchantId: string,
  id: string,
  body: UpdateProviderConfigInput,
) =>
  apiFetch<ProviderConfig>(
    `/admin/merchants/${merchantId}/provider-configs/${id}`,
    { method: "PATCH", body },
  );

export const deleteProviderConfig = (merchantId: string, id: string) =>
  apiFetch<{ id: string; deleted: boolean }>(
    `/admin/merchants/${merchantId}/provider-configs/${id}`,
    { method: "DELETE" },
  );
